/** Reka-internal popper wrapper attribute */
export const POPPER_WRAPPER_ATTR = 'data-reka-popper-content-wrapper';

const POPPER_WRAPPER_SELECTOR = `[${POPPER_WRAPPER_ATTR}]`;
const CLOSED_POPOVER_TRIGGER_SELECTOR = '[aria-haspopup][data-state="closed"]';

/** A nested popover portals to `<body>`, so its interactions reach the outer popover as outside-dismissal. */
export function isInsideOtherPopper(target: EventTarget | null, ownContent: HTMLElement | null): boolean {
	if (!(target instanceof Element)) return false;

	const targetWrapper = target.closest(POPPER_WRAPPER_SELECTOR);
	if (!targetWrapper) return false;

	const ownWrapper = ownContent?.closest(POPPER_WRAPPER_SELECTOR);
	if (!ownWrapper) return false;

	return targetWrapper !== ownWrapper;
}

/** A sibling trigger clicked while another popover is open is still `closed` at pointerdown. */
export function isInsideClosedPopoverTrigger(target: EventTarget | null): boolean {
	if (!(target instanceof Element)) return false;
	return target.closest(CLOSED_POPOVER_TRIGGER_SELECTOR) !== null;
}
